<template>
  <div class="container">
    <Tbheader
      :tipo="tipo + ' - Banner'"
      :novo="novo"
      :titulo="contentEdit.titulo"
      :icone="icone"
    />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-2 form-group">
          <label>Idioma:</label>
          <select
            v-model="contentEdit.idioma"
            name="idioma"
            id="idioma"
            class="form-control required valid"
            value
          >
            <option
              :key="idioma.abreviacao"
              v-for="idioma in contentIdiomas"
              :value="idioma.abreviacao"
            >
              {{ idioma.abreviacao }}
            </option>
          </select>
        </div>
        <div class="col-2 form-group">
          <label>Ordem:</label>
          <input
            type="number"
            v-model="contentEdit.ordem"
            name="ordem"
            id="ordem"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-6 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.ativo == true }"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                @change="fnAtiva()"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.ativo == false }"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                @change="fnAtiva()"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-12 form-group">
          <label>Frase:</label>
          <textarea
            type="text"
            v-model="contentEdit.frase"
            name="frase"
            id="frase"
            class="form-control required valid"
            value
          >
          </textarea>
        </div>
        <div class="col-2 form-group">
          <label>Direção do texto:</label>
          <select
            v-model="contentEdit.direcao"
            name="direcao"
            id="direcao"
            class="form-control required valid"
            value
          >
            <option value="slider-caption-left">Esquerda</option>
            <option value="slider-caption-center">Centro</option>
            <option value="slider-caption-right">Direita</option>
          </select>
        </div>
        <div class="col-md-2 form-group">
          <label>Mostrar título:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="mostraTituloativo"
              :class="{ 'active': contentEdit.mostraTitulo == true }"
            >
              <input
                type="radio"
                name="mostraTitulo"
                id="mostraTituloativo"
                @change="fnMostraTitulo()"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="mostraTituloinativo"
              :class="{ 'active': contentEdit.mostraTitulo == false }"
            >
              <input
                type="radio"
                name="mostraTitulo"
                id="mostraTituloinativo"
                @change="fnMostraTitulo()"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-md-2 form-group">
          <label>Modo Dark:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="darkativo"
              :class="{ 'active': contentEdit.dark == true }"
            >
              <input
                type="radio"
                name="dark"
                id="darkativo"
                @change="fnDark()"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="darkinativo"
              :class="{ 'active': contentEdit.dark == false }"
            >
              <input
                type="radio"
                name="dark"
                id="darkinativo"
                @change="fnDark()"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>

        <div class="col-sm-12"><label>Imagem:</label></div>
        <div class="col-sm-6 text-center">
          <div
            class="areaFoto"
            :class="contentEdit.imagem ? 'ativo' : ''"
            @click="$refs.imagem.click()"
            :style="
              contentEdit.imagem && carregado
                ? 'background:url(' + contentEdit.imagem + ')'
                : 'background:url()'
            "
          >
            <i class="icon-cloud-upload-alt"></i>
            <input
              type="file"
              @change="OnFileSelected"
              id="imagem"
              name="imagem"
              ref="imagem"
              style="display: none"
              class="form-control"
              accept="image/*"
            />
          </div>
          <button
            v-if="contentEdit.imagem && tipo != 'Copiando'"
            class="btn btn-danger"
            @click.prevent="fnRemoveFoto('imagem', 1)"
          >
            Remover foto
          </button>
          <button
            type="button"
            v-if="tipo == 'Copiando'"
            class="btn btn-info"
            @click.prevent="$refs.imagem.click()"
          >
            Alterar foto
          </button>
        </div>
        <div class="col-12 form-group"></div>

        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >
            Gravar
          </button>
        </div>
      </div>
    </form>
    <div style="display: none">
      {{ carregadoImg }}
    </div>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData, getSuccess, getError, urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error: null,
      contentFotos: [],
      carregado: true,
      carregadoIm: false,
      idiomaAnterior: null,
      files: [],
      imagem: [],
      contentIdiomas: [],
      logotipoRodape: [],
      contentEdit: {
        titulo: "",
        ativo: false,
        mostraTitulo: true,
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  components: { Tbheader },
  methods: {
    OnFileSelected(event) {
      if (event.target.id == "imagem") {
        this.contentEdit.imagem = URL.createObjectURL(event.target.files[0]);
        this.imagem = event.target.files[0];
        this.carregado = true;
        this.carregadoIm = true;
      }
    },
    fnRemoveFoto(tipo, i) {
      var filename = "";
      if (i == 1) {
        filename = this.contentEdit.imagem
          .split("/")
          .pop()
          .split("#")[0]
          .split("?")[0];
        this.contentEdit.imagem = null;
      }
      this.$http
        .delete(
          "gape/upload/gape/banners/" +
            this.contentEdit.idioma +
            "/" +
            filename +
            "/arquivo"
        )
        .then((res) => {
          console.log(res);
        });
    },
    fnCopyFoto() {
      var filename = "";
      var idioma = "";
      filename = this.contentEdit.imagem
        .split("/")
        .pop()
        .split("#")[0]
        .split("?")[0];
      idioma = this.contentEdit.imagem.split("/");

      this.contentEdit.imagem = null;
      var idiomaAnterior = idioma[5];
      this.$http
        .post(
          "gape/upload/gape/banners/" +
            this.contentEdit.idioma +
            "/" +
            filename +
            "/" +
            idiomaAnterior +
            "/copiar"
        )
        .then((res) => {
          console.log(res);
        });
    },
    GetFilename(url) {
      if (url) {
        var m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if (this.imagem.name != undefined) {
        fd.append("files", this.imagem, this.imagem.name);
      }

      this.$http
        .post("gape/upload/gape/" + this.contentEdit.idioma + "/banners", fd)
        .then(() => {
          this.carregado = true;
        });
    },
    fnLimpa() {
      this.contentEdit.titulo = "";
      this.contentEdit.ativo = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
      this.contentEdit.ativo = !this.contentEdit.ativo;
    },
    fnMostraTitulo() {
        this.contentEdit.mostraTitulo = !this.contentEdit.mostraTitulo;
        console.log(this.contentEdit.mostraTitulo);
    },
    fnDark() {
        this.contentEdit.dark = !this.contentEdit.dark;
    },
    fnCancela() {
      this.$router.push({ path: `/gape/banners/` });
    },
    async formSubmit(e) {
      e.preventDefault();
      let metodo = null;
      let completaUrl = null;
      if (this.$route.meta.breadcrumb == "Copiar") {
        metodo = "post";
        delete this.contentEdit["bannerId"];
        completaUrl = "";
      } else {
        metodo = this.$route.params.id ? "put" : "post";
        completaUrl = this.$route.params.id ? "/" + this.$route.params.id : "";
      }

      const imgUrl =
        urlApi + "Upload/gape/" + this.contentEdit.idioma + "/banners/";
      var chamaUpload = false;
      if (this.imagem.name != undefined) {
        chamaUpload = true;
        this.contentEdit.imagem = imgUrl + this.imagem.name;
      }
        if (this.idiomaAnterior != this.contentEdit.idioma) {
          this.contentEdit.imagem = this.contentEdit.imagem.replace(this.idiomaAnterior,this.contentEdit.idioma)
        }

      let data = await this.$http[metodo](
        "/gape/banner" + completaUrl,
        this.contentEdit
      )
        .then(() => {
          if (chamaUpload) {
            this.OnUpload();
          }
          if (this.tipo == "Copiando") {
            this.fnCopyFoto();
          }
          getSuccess();
          this.fnLimpa();
          this.fnCancela();
        })
        .catch((e) => {
          return e;
        });
      this.error = data;
    },
    fnGetError(e) {
      getError(e);
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        if (this.$route.meta.breadcrumb == "Copiar") {
          this.tipo = "Copiando";
          this.novo = true;
          this.fnCarregaItems(this.$route.params.id);
        } else {
          this.tipo = "Editando";
          this.novo = false;
          this.fnCarregaItems(this.$route.params.id);
        }
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false;
        this.contentEdit.mostraTitulo = true;
        this.contentEdit.dark = false;
        this.contentEdit.imagem = null;
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi + "gape/banner/" + valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close();
      if (this.tipo == "Copiando") {
          this.idiomaAnterior = this.contentEdit.idioma
      }
    },
    async fnCarregaIdiomas() {
      let data = await getData(this.urlApi + "gape/idiomas/");
      this.contentIdiomas = data[0].content;
    },
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function () {
      return this.fnIsEdit();
    },
    temErro() {
      if (this.error) {
        return this.fnGetError(this.error);
      } else {
        return "";
      }
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.contentEdit;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.fnCarregaIdiomas();
  },
};
</script>

<style lang="scss" scoped>
#editor1,
#editor2,
#editor3 {
  min-height: 50vh;
}
</style>